import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
import { $3l5vvh8yg0ier as $ } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onSubscription(_this__u8e3s4, action) {
  return new (SubscribedSharedFlow())(_this__u8e3s4, action);
}
var SubscribedFlowCollectorClass;
function SubscribedFlowCollector() {
  if (SubscribedFlowCollectorClass === VOID) {
    class $_0 {
      constructor(collector, action) {
        this.collector_1 = collector;
        this.action_1 = action;
      }
      *onSubscription_q7qr5n_k$($completion) {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.get_context_h02k06_k$();
        var safeCollector = new (SafeCollector())(this.collector_1, tmp$ret$0);
        try {
          yield* $(this.action_1(safeCollector, $completion), $completion);
        }finally {
          safeCollector.releaseIntercepted_5cyqh6_k$();
        }
        var tmp = this.collector_1;
        if (tmp instanceof SubscribedFlowCollector())
          yield* this.collector_1.onSubscription_q7qr5n_k$($completion);
        return Unit_instance;
      }
      *emit_t92u1f_k$(value, $completion) {
        yield* this.collector_1.emit_t92u1f_k$(value, $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($_0, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector()], [0, 1]);
    SubscribedFlowCollectorClass = $_0;
  }
  return SubscribedFlowCollectorClass;
}
var SubscribedSharedFlowClass;
function SubscribedSharedFlow() {
  if (SubscribedSharedFlowClass === VOID) {
    class $ {
      constructor(sharedFlow, action) {
        this.sharedFlow_1 = sharedFlow;
        this.action_1 = action;
      }
      *collect_ve9kyv_k$(collector, $completion) {
        yield* this.sharedFlow_1.collect_ve9kyv_k$(new (SubscribedFlowCollector())(collector, this.action_1), $completion);
        return throwKotlinNothingValueException();
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ve9kyv_k$(collector, $completion);
      }
    }
    initMetadataForClass($, 'SubscribedSharedFlow', VOID, VOID, VOID, [1]);
    SubscribedSharedFlowClass = $;
  }
  return SubscribedSharedFlowClass;
}
//region block: exports
export {
  SubscribedFlowCollector as SubscribedFlowCollector17ch8by19noql,
  onSubscription as onSubscription3iwvbdmbwg7iq,
};
//endregion

//# sourceMappingURL=Share.mjs.map
